import React, { useState, useEffect } from 'react';

// Base URL del worker de autenticación
const AUTH_API_BASE = 'https://auth.tareia.com';

const CTA = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Cargar script de Turnstile
  useEffect(() => {
    // Verificar si ya existe el script
    const existingScript = document.querySelector('script[src*="turnstile"]');
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error('Error cargando Turnstile');
    };
    document.head.appendChild(script);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    console.log('🚀 Iniciando proceso de registro...');

    if (!validateEmail(email)) {
      setError('Por favor ingresa un email válido');
      return;
    }

    // Obtener token de Turnstile
    const turnstileToken = window.turnstile?.getResponse();
    if (!turnstileToken) {
      setError('Por favor completa la verificación de seguridad');
      return;
    }

    // Obtener valor del campo honeypot
    const formData = new FormData(e.target);
    const schoolName = formData.get('school_name') || '';

    setIsLoading(true);
    localStorage.setItem('email', email);

    try {
      console.log('📧 Registrando en Brevo...');
      // 1. Registro en Brevo (flujo actual)
      const response = await fetch('https://tareia-register-email-api.joseeloyvelazquezojeda.workers.dev/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          turnstileToken: turnstileToken,
          school_name: schoolName
        })
      });

      if (response.ok) {
        const data = await response.json();
        const status = data.status;
        console.log('✅ Registro Brevo exitoso:', status);
        
        try {
          // Registrar acceso en Worker - SEGURIDAD REAL
          console.log('🔄 Registrando acceso en Worker...');
          const accessResponse = await fetch(`${AUTH_API_BASE}/api/registro-acceso`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include'
          });

          console.log('📡 Respuesta del Worker:', accessResponse.status, accessResponse.statusText);

          if (!accessResponse.ok) {
            const errorText = await accessResponse.text();
            console.error('❌ Error del Worker:', errorText);
            throw new Error(`Error estableciendo acceso: ${accessResponse.status}`);
          }
          
          console.log('✅ Cookie de acceso establecida en el servidor');
          
          // Redirigir - la cookie está en el servidor
          console.log('🔄 Redirigiendo a /gracias...');
          if (status === 'created') {
            window.location.href = `/gracias?status=new`;
          } else if (status === 'exists') {
            window.location.href = `/gracias?status=exists`;
          } else {
            window.location.href = `/gracias?status=new`;
          }
          
        } catch (workerError) {
          console.error('❌ Error en Worker:', workerError);
          
          // Guardar error en localStorage para debug
          localStorage.setItem('debug_worker_error', workerError.message);
          
          // Por ahora, continuar sin Worker para que funcione
          console.log('⚠️ Continuando sin Worker...');
          if (status === 'created') {
            window.location.href = `/gracias?status=new&temp=true`;
          } else if (status === 'exists') {
            window.location.href = `/gracias?status=exists&temp=true`;
          } else {
            window.location.href = `/gracias?status=new&temp=true`;
          }
        }
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('❌ Error en Brevo:', errorData);
        setError(errorData.message || 'Error en el envío. Por favor, inténtalo de nuevo');
        setIsLoading(false);
        // Reset Turnstile
        if (window.turnstile) {
          window.turnstile.reset();
        }
      }
    } catch (err) {
      console.error('❌ Error general:', err);
      localStorage.setItem('debug_general_error', err.message);
      setError('Ocurrió un error. Por favor, inténtalo de nuevo');
      setIsLoading(false);
      // Reset Turnstile
      if (window.turnstile) {
        window.turnstile.reset();
      }
    }
  };

  return (
    <section id="cta" className="bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-600 section-padding">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight">
            Sé de los primeros en probar Tareia
          </h2>

          <div className="card p-6 sm:p-8 md:p-12 max-w-xl mx-auto">
            <div className="text-center mb-6 sm:mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">T</span>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div className="text-gray-700 text-sm text-center px-2">
                <p className="text-center mb-1">
                  👩‍🏫 Regístrate para ser de los primeros docentes
                </p>
                <p className="mb-2">en probar <span className="text-primary-600 font-bold">Tareia</span> cuando esté disponible.</p>
                <p className="text-xs text-gray-400">
                  📄 Incluye PDF con actividades de muestra descargables.
                </p>
              </div>
              <div className="px-2">
                <input
                  type="email"
                  id="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  className={`w-full px-3 sm:px-4 py-3 sm:py-4 border rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all text-base sm:text-lg ${
                    error ? 'border-red-500' : 'border-gray-300'
                  } ${isLoading ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  placeholder="tu@email.com"
                />
                
                {/* Campo honeypot - oculto para usuarios, visible para bots */}
                <input
                  type="text"
                  name="school_name"
                  autoComplete="off"
                  style={{ display: 'none' }}
                  tabIndex="-1"
                />
                
                {error && (
                  <p className="text-red-500 text-sm mt-2 text-left">{error}</p>
                )}
              </div>

              {/* Widget de Turnstile */}
              <div className="flex justify-center mb-4 px-12">
                <div className="scale-75 origin-center">
                  <div 
                    className="cf-turnstile" 
                    data-sitekey="0x4AAAAAACwtUYvcYYmAZoYF"
                    data-theme="light"
                    data-language="es"
                  ></div>
                </div>
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className={`w-full font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl transition-all duration-200 shadow-lg text-base sm:text-lg ${
                  isLoading
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white hover:shadow-xl transform hover:-translate-y-0.5'
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Registrando...
                  </div>
                ) : (
                  'Quiero acceso anticipado'
                )}
              </button>

              <div className="space-y-1 text-center px-2">
                <p className="text-xs text-gray-400">Toma menos de 10 segundos</p>

                <p className="text-xs text-gray-400 leading-relaxed">
                  ⚡ Acceso anticipado gratuito. Sin compromiso.
                </p>

                <p className="text-xs text-gray-400 px-2">
                  👩‍🏫 Docentes de Latinoamérica ya se están registrando para probar <span className="text-primary-600 font-bold">Tareia</span>.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
